import React from "react";
import { connect } from "react-redux";
import { Grid, Row, Col } from "react-bootstrap";
import "./styles.css";
import BasketDeliveryAddress from "./basket-delivery-address";
import InMyBasket from "./in-my-basket";
import BasketFooter from "./basket-footer";

const BasketDropdown = () => {
  const handleClick = event => {
    event.stopPropagation();
  };
  return (
    <Grid className="basket-dropdown">
      <Row>
        <Col
          md={6}
          onClick={e => handleClick(e)}
          className="orders-basket pull-right"
        >
          <BasketDeliveryAddress />
          <InMyBasket />
          <BasketFooter />
        </Col>
      </Row>
    </Grid>
  );
};

const mapStateToProps = state => {
  return {
    basket: state.orders.new.basket.line_items,
    basketTotal: state.orders.new.basket_total,
    basketTotalWithCurrentPromotions:
      state.orders.new.basket_total_with_current_promotions,
    features: state.features,
  };
};

export default connect(mapStateToProps)(BasketDropdown);



// WEBPACK FOOTER //
// ./src/components/new-order/basket/basket-dropdown.jsx